import { type Meta } from '../types/docs';

const META: Meta = {
  description: "User copied an asset's or board's breadcrumb-style path to the clipboard",
  name: 'copied_file_path',
  params: [
    {
      description: 'Where the copy action was triggered from',
      name: 'location',
      required: true,
      type: 'enum',
      values: ['asset-details', 'asset-modal-header', 'board-header-menu', 'board-breadcrumb'],
    },
  ],
};

export default META;
